var LocationLegacyModule = /** @class */ (function () {
    function LocationLegacyModule() {
    }
    return LocationLegacyModule;
}());
export { LocationLegacyModule };
